import { useApi } from 'services';

export const useSaveIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue`, 'POST', {}, {});

export const useGetBindIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue/bind-option`, 'GET', {}, {});

export const useConfirmIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue/confirm`, 'GET', {}, {});

export const useDeclineIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue/decline`, 'DELETE', {}, {});

export const useRequestIssueAction = () => useApi(`/issue/v2`, 'POST', {}, {}, true);

export const useRequestSompoGetInternalProcessNumber = () => useApi(`/sompo/generate-internal-process`, 'POST', {}, {}, true);

export const useRequestSompoGetIssueQuotePolicy = () => useApi(`/sompo/issue-quote-policy`, 'POST', {}, {}, true);

export const useRequestSompoGetInstallments = () => useApi(`/sompo/installments`, 'POST', {}, {}, true);

export const useRequestSompoGetIssueQuoteBill = () => useApi(`/sompo/issue-quote-bill`, 'POST', {}, {}, true);

export const useSignatureDocumentSompo = () => useApi('/sompo/document-sign/full', 'POST', {}, {}, true);

export const useRequestSompoGetSAP = () => useApi(`/sompo/sap`, 'GET', {}, {}, true);

export const useRequestSompoUpdateBorrower = () => useApi(`/sompo/borrower-sro`, 'POST', {}, {}, true);
